import { ApiError } from './ApiError';
import type { IFieldErrors } from './IFieldErrors';

export class ValidationError extends ApiError {
	constructor(public errors: IFieldErrors) {
		super('Validation failed');
	}
}
